import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import {
  selectQueryParams,
  changeQueryParams,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import DefaultSelect from 'components/Common/Inputs/DefaultSelect';

const promMaterialsListRN =
  'promotionalMaterialsModule.lists.promMaterialsList';

class RightSidebarPromMat extends Component {
  handleUpdateStateQueryParams = paramObject => {
    this.props.changeQueryParams(paramObject);
    this.props.sendRequest();
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-sidebar-sticky">
          <div className="page-sidebar-sticky-wrp">
            <div
              className="panel-group panel-group-side"
              id="panelGroupFilter"
              role="tablist"
              aria-multiselectable="true"
            >
              <NavLink
                to="/referral-program/promotional-materials/my-link"
                activeClassName="active"
                className="list-group-item"
              >
                <span className="list-group-item-val">
                  {t('Партнерская ссылка')}
                </span>
              </NavLink>
              <NavLink
                to="/referral-program/promotional-materials/banners"
                activeClassName="active"
                className="list-group-item border-b"
              >
                <span className="list-group-item-val">{t('Баннеры')}</span>
              </NavLink>
              <div className="tab-content">
                <div className="tab-pane link" />
                <div
                  className={`tab-pane banners ${
                    this.props.location.pathname ===
                    '/referral-program/promotional-materials/banners'
                      ? 'active'
                      : ''
                  }`}
                >
                  <div className="panel panel-default border-b">
                    <div className="panel-body">
                      <div className="form-group m-b-0">
                        <DefaultSelect
                          btnClassName={'btn-sm'}
                          selectArrItems={Object.keys(
                            this.props.promMatResolutionList
                          ).map(key => ({
                            value: key,
                            title: this.props.promMatResolutionList[key]
                          }))}
                          value={this.props.selectQueryParams.img_resolution}
                          selectTitleNullValue={t('Все размеры')}
                          handleChangeValue={value => {
                            this.handleUpdateStateQueryParams(
                              {
                                img_resolution: value
                              },
                              true
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <div className="form-group m-b-0">
                        <DefaultSelect
                          btnClassName={'btn-sm'}
                          selectArrItems={[
                            {
                              value: 1,
                              title: t('Без анимации')
                            },
                            {
                              value: 2,
                              title: t('С анимацией')
                            }
                          ]}
                          value={this.props.selectQueryParams.is_animation}
                          selectTitleNullValue={t('С анимацией и без')}
                          handleChangeValue={value => {
                            this.handleUpdateStateQueryParams(
                              {
                                is_animation: value
                              },
                              true
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

RightSidebarPromMat.defaultProps = {
  promMatResolutionList: {}
};

RightSidebarPromMat.propTypes = {
  // IN
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,

  // CONNECT
  sendRequest: PropTypes.func.isRequired,
  selectQueryParams: PropTypes.shape({
    img_resolution: PropTypes.string,
    is_animation: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  promMatResolutionList: PropTypes.shape({})
};

const mapStateToProps = state => ({
  selectQueryParams: selectQueryParams(state, promMaterialsListRN),
  promMatResolutionList: getItemFromRefList(state, 'promMatResolutionList')
});
const mapDispatchToProps = dispatch => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(promMaterialsListRN, queryParams)),
  sendRequest: () => dispatch(sendRequest(promMaterialsListRN))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RightSidebarPromMat)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/PromotionalMaterials/RightSidebarPromMat/RightSidebarPromMat.js